import styled from 'styled-components';

export const S = {
  Wrapper: styled.div`
    width: 100%;
    display: flex;
    height: 80px;
    margin-bottom: 15px;
  `,
  Image: styled.img`
    width: 30%;
  `,
  ItemDetails: styled.div`
    width: 70%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 10px 20px;
  `,
};
